import styled from 'styled-components';
// import { COLOR } from '@src/styles/color';

export const StyledNewVoiceAction = styled('div')`
  display: flex;
  align-items: ${({ isCard }) => (isCard ? 'flex-end' : 'center')};
  flex-direction: ${({ isCard }) => (isCard ? 'column' : 'row')};
  gap: 8px;
  justify-content: end;
  min-width: 72px;
  .new-voice-action-container {
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: end;
  }
`;
